import React, { useState } from "react";
import { Eye, EyeOff, Plus } from "lucide-react";

export const MARKUP = 1.5;
export const suggested = (cost) => Math.round(cost * MARKUP * 100) / 100;
export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const PriceRow = ({ id, label, cost, note, onAdd }) => {
  const [show, setShow] = useState(false);
  return (
    <div data-testid={`price-row-${id}`} className="flex flex-wrap items-center gap-2 py-1.5 border-t border-[#c99658]/15 first:border-t-0">
      <span className="flex-1 min-w-[150px] text-[12.5px] text-[#0f2420]/80 leading-tight">{label}</span>
      {cost == null ? (
        <span className="text-[11px] italic text-neutral-500">{note || "Ask for quote"}</span>
      ) : (
        <>
          <span data-testid={`suggested-${id}`} className="font-semibold text-[#0f2420] text-sm tabular-nums w-24 text-right ml-auto">{money(suggested(cost))}</span>
          <button
            type="button"
            data-testid={`toggle-cost-${id}`}
            onClick={() => setShow((s) => !s)}
            aria-label={show ? "Hide cost" : "Show cost"}
            className={`flex items-center gap-1 h-7 px-2 text-[10px] tracking-[0.15em] uppercase font-raleway border transition-colors w-[92px] justify-center ${
              show ? "border-[#7a5b2f] bg-[#7a5b2f] text-white" : "border-neutral-300 text-neutral-500 hover:border-[#7a5b2f] hover:text-[#7a5b2f]"
            }`}
          >
            {show ? <EyeOff size={12} /> : <Eye size={12} />}
            {show ? <span data-testid={`cost-${id}`} className="tabular-nums tracking-normal text-[11px]">{money(cost)}</span> : "Cost"}
          </button>
          {onAdd && (
            <button
              type="button"
              data-testid={`add-${id}`}
              onClick={onAdd}
              aria-label="Add to estimate"
              className="h-7 w-7 flex items-center justify-center bg-[#c99658] text-[#0f2420] hover:bg-[#0f2420] hover:text-white transition-colors"
            >
              <Plus size={14} />
            </button>
          )}
        </>
      )}
    </div>
  );
};
